import { CloseOutlined, MenuOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, Flex, Row, Typography } from 'antd';
import { localize } from 'mixins/helpers';
import React, { useEffect, useState } from 'react';
import MobilePhoneIcon from '../../../assets/svg/mobile-phone.svg';
import PhoneIcon from '../../../assets/svg/phone.svg';
import ContactCenter from '../contact-center/contact-center';
import { getMenuList } from '/react4xp/parts/service-link-img/actions';

const HeaderMobileMenu = (props) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const openMenu = () => setIsMenuOpen(true);
    const closeMenu = () => setIsMenuOpen(false);

    const [menuItems, setMenuItems] = useState([]);

    useEffect(() => {
        getMenuList(props.context).then((value) => {
            if (value.data) {
                setMenuItems(value.data.filter((x) => !x.dataAsJson.menu));
            }
        });
    }, []);

    const getMenuItemHref = (path) => {
        return '/' + props.language + path.replace('/isna-portal-cms', '');
    };

    return (
        <>
            <Button
                onClick={openMenu}
                type={'text'}
                size={'large'}
                icon={<MenuOutlined className="header_menu_button__icon" />}
                className="header_menu_button"
            >
                {!props.user && localize('bvi-menu', props.translations)}
            </Button>
            <Drawer
                placement={'top'}
                open={isMenuOpen}
                onClose={closeMenu}
                closable={{
                    closeIcon: <CloseOutlined style={{ color: 'white' }} />,
                }}
                style={{ backgroundColor: '#164B84', color: 'white', fontSize: 20 }}
                height={300}
            >
                <Row gutter={[20, 20]}>
                    <Col xs={24}>
                        <Typography.Text
                            style={{
                                color: 'white',
                                marginBottom: 10,
                                display: 'block',
                            }}
                        >
                            {localize('header-contact-center', props.translations)}
                        </Typography.Text>
                        <Flex gap={10}>
                            <ContactCenter
                                config={{
                                    phone: props.config.short_phone,
                                }}
                                icon={<MobilePhoneIcon />}
                            />
                            <ContactCenter
                                config={{
                                    phone: props.config.long_phone,
                                }}
                                icon={<PhoneIcon />}
                            />
                        </Flex>
                    </Col>

                    <Col xs={13}>
                        <Flex
                            vertical
                            gap={20}
                        >
                            {menuItems.slice(0, 3).map((item) => (
                                <a href={getMenuItemHref(item._path)}>{item.displayName}</a>
                            ))}
                        </Flex>
                    </Col>

                    <Col xs={11}>
                        <Flex
                            vertical
                            gap={20}
                        >
                            {menuItems.slice(3).map((item) => (
                                <a href={getMenuItemHref(item._path)}>{item.displayName}</a>
                            ))}
                        </Flex>
                    </Col>
                </Row>
            </Drawer>
        </>
    );
};

export default HeaderMobileMenu;
